import { css } from 'styled-components';
import { fullCenterRow } from 'styles/mixins/flex/row/fullCenterRow';
import { whiteTheme } from 'styles/themes/whiteTheme';

export const button = css`
  ${fullCenterRow};
  padding: 17px 0;
  cursor: pointer;
  ${({ theme, disabled }) => css`
    font-weight: ${whiteTheme.fontWeights.bolder};

    ${disabled &&
    css`
      cursor: default;
    `};
  `};
`;
